var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.024 21v-2.15a5.1 5.1 0 0 1-2.287-1.15q-.963-.85-1.413-2.4l1.85-.75q.375 1.2 1.113 1.825.737.625 1.937.625 1.026 0 1.738-.462.712-.463.712-1.438 0-.875-.55-1.387-.549-.513-2.55-1.163-2.15-.675-2.95-1.613t-.8-2.287q0-1.625 1.05-2.525t2.15-1.025V3h2v2.1q1.25.2 2.063.913a4.2 4.2 0 0 1 1.187 1.737l-1.85.8q-.3-.8-.85-1.2-.549-.4-1.5-.4-1.1 0-1.675.487-.575.488-.575 1.213 0 .825.75 1.3t2.6 1q1.725.5 2.613 1.588.887 1.086.887 2.512 0 1.774-1.05 2.7-1.05.925-2.6 1.15V21z"
  })));
};
export default SvgDollar;